export enum NotificationType {
    SYSTEM = 'system',
    COURSE_PROCESSING = 'course_processing',
    COURSE_PUBLISHED = 'course_published',
    NEW_MESSAGE = 'new_message',
    NEW_FOLLOWER = 'new_follower',
    NEW_REVIEW = 'new_review',
    ACHIEVEMENT = 'achievement',
    REMINDER = 'reminder',
    LEARNER_QUESTION = 'learner_question',
    CREATOR_ANSWERED = 'creator_answered',
    MODE_UNLOCKED = 'mode_unlocked',
}

export enum NotificationPriority {
    LOW = 'low',
    NORMAL = 'normal',
    HIGH = 'high',
    URGENT = 'urgent',
}

export interface Notification {
    id: string;
    userId: string;
    type: NotificationType;
    priority: NotificationPriority;
    title: string;
    message: string;
    actionUrl?: string;
    actionLabel?: string;
    metadata: Record<string, any>;
    isRead: boolean;
    readAt?: string;
    isDismissed: boolean;
    emailSent: boolean;
    createdAt: string;
    expiresAt?: string;
}

export interface NotificationPreferences {
    id: string;
    userId: string;
    preferences: Record<string, { push: boolean; email: boolean }>;
    emailEnabled: boolean;
    pushEnabled: boolean;
    quietHoursStart?: string;
    quietHoursEnd?: string;
    timezone: string;
}

export interface PaginatedNotifications {
    items: Notification[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
}
